import { render, staticRenderFns } from "./AdConsentConfirm.vue?vue&type=template&id=c95eb696&scoped=true"
import script from "./AdConsentConfirm.vue?vue&type=script&lang=js"
export * from "./AdConsentConfirm.vue?vue&type=script&lang=js"
import style0 from "./AdConsentConfirm.vue?vue&type=style&index=0&id=c95eb696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95eb696",
  null
  
)

export default component.exports